import { useCallback } from 'react'
import { useChannelListContext, useChatContext } from 'stream-chat-react'
import { chatSort } from '@packages/chat'

export const useChannelListRefresh = (filters: Record<string, any>) => {
  const { client } = useChatContext('useChannelListRefresh')
  const { channels, setChannels } = useChannelListContext('useChannelListRefresh')

  const refreshList = useCallback(async () => {
    const updated = await client.queryChannels(filters, chatSort, {
      limit: Math.max(channels.length, 10),
      presence: true,
      state: true,
      watch: true,
    })
    setChannels(updated)
  }, [client, filters, channels.length, setChannels])

  return { refreshList }
}
